var React = require('react');

function IconSelfServ (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.5 12.5C9.05311 12.5 6.25 9.69689 6.25 6.24997C6.25 2.80467 9.05311 0 12.5 0C15.9469 0 18.75 2.80467 18.75 6.24997C18.75 9.69689 15.9469 12.5 12.5 12.5ZM12.5 3.12498C10.7766 3.12498 9.37506 4.52498 9.37506 6.24997C9.37506 7.9734 10.7766 9.37502 12.5 9.37502C14.2235 9.37502 15.625 7.9734 15.625 6.24997C15.625 4.52498 14.2235 3.12498 12.5 3.12498ZM0 25V23.3929C0 17.7148 5.14061 13.75 12.5 13.75C19.8594 13.75 25 17.7148 25 23.3929V25H0ZM3.37343 21.7857H21.6281C20.6938 18.88 17.2016 16.9643 12.5016 16.9643C7.80154 16.9643 4.3078 18.88 3.37343 21.7857Z","fill":"#6B4E9F"}));
}

IconSelfServ.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = IconSelfServ;

IconSelfServ.default = IconSelfServ;
